
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 14 14"}},_vm.$listeners),[_c('path',{attrs:{"d":"M11.667 11.667H2.333V2.333H7V1H2.333A1.333 1.333 0 001 2.333v9.333A1.333 1.333 0 002.333 13h9.333A1.337 1.337 0 0013 11.667V7h-1.333zM8.333 1v1.333h2.393L4.173 8.887l.94.94 6.553-6.553v2.393H13V1z"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  